import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackCallbackPopupOpen } from './tracking';
import { openRequestCallbackPopup } from '../../actions/requestCallback';
import { getBuilder, getGaLabel } from '../../selectors/newbuilding';
import { TRequestCallbackOpener } from '../../types/requestCallback';
import { getPhoneString } from '../../utils/text';

export function useCallbackButton(placeType: TRequestCallbackOpener): [boolean, () => void] {
  const builder = useSelector(getBuilder);
  const gaLabel = useSelector(getGaLabel);
  const dispatch = useDispatch();

  const callbackPhone = React.useMemo(() => (builder ? getPhoneString(builder.phone) : null), [builder]);
  const isAvailable = !!callbackPhone;

  const handleClick = React.useCallback(() => {
    trackCallbackPopupOpen(gaLabel, placeType);

    dispatch(openRequestCallbackPopup(placeType));
  }, [dispatch, gaLabel, placeType]);

  return [isAvailable, handleClick];
}
